import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    List,
    ListItem,
    withStyles,
    ListItemText,
    ListItemAvatar,
    Avatar
} from '@material-ui/core';
import logo from '../../assets/img/logo.png';
import payment from '../../assets/images/payment.png';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import footerStyle from 'assets/jss/material-kit-react/components/footerStyle.jsx';
import moment from 'moment';
import withUser from '../HOC/HOCwithUser.jsx';
import { APP_NAME } from '../../utils/config/constants';
import { withTheme } from '@material-ui/core/styles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter, Link } from 'react-router-dom';
import { SITE_URL } from '../../utils/config/constants.js';
let isMounted = false;
class Footer extends Component {
    constructor() {
        super();
        this.state = {
            providers: [],
            services: [],
            redirect: false,
            providerData: []
        };
    }
    componentDidMount() {
        isMounted = true;
        this.getData();
    }
    getData() {
        if (isMounted) {
            this.props.allProviderListingAction(
                {
                    featured: false,
                    filter: 0,
                    text: '',
                    type: ''
                },
                this.onDone
            );
            this.props.topServiceListAction(this.onServiceDone);
        }
    }
    componentWillUnmount() {
        isMounted = false;
    }
    redirectLink = serviceId => {
        this.props.serviceProviderListAction(
            {
                serviceId: serviceId,
                type: 2,
                day: new Date().getDay(),
                offset: new Date().getTimezoneOffset()
            },
            this.onredirectDone
        );
        this.setState({ clickedServiceId: serviceId });
    };
    onredirectDone = (success, data) => {
        if (success) {
            this.setState({
                providerData: data.data.providerList,
                redirect: true
            });
        }
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({ providers: data.data });
        }
    };
    onServiceDone = (success, data) => {
        if (success) {
            this.setState({ services: data.data });
        }
    };
    renderCmsDetail = slug => {
        this.props.history.push(`/page/${slug}`);
    };
    render() {
        const { classes, whiteFont } = this.props;

        const aClasses = classNames({
            [classes.a]: true,
            [classes.footerWhiteFont]: whiteFont
        });

        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/provider/list/${this.state.clickedServiceId}`,
                state: {
                    serviceId: this.state.clickedServiceId,
                    providerData: this.state.providerData
                }
            });
        }
        return (
            <div>
                <footer id="colophon" className="site-footer clearfix">
                    <div
                        id="quaternary"
                        className="sidebar-container "
                        role="complementary"
                    >
                        <div className="sidebar-inner">
                            <div className="widget-area clearfix">
                                <div
                                    id="azh_widget-2"
                                    className="widget widget_azh_widget"
                                >
                                    <div data-section="section">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-4 foot-logo">
                                                    {' '}
                                                    <img
                                                        src={logo}
                                                        width="35px"
                                                        height="auto"
                                                        style={{ marginTop: 3 }}
                                                    />
                                                    <p className="hasimg">
                                                        {
                                                            this.props.constants
                                                                .about_us
                                                        }
                                                    </p>
                                                </div>
                                                <div className="col-sm-4 col-md-4">
                                                    <h4>
                                                        <FormattedMessage
                                                            id="support"
                                                            defaultMessage="Support"
                                                        />
                                                        &nbsp;&amp;&nbsp;
                                                        <FormattedMessage
                                                            id="help"
                                                            defaultMessage="Help"
                                                        />
                                                    </h4>
                                                    <List className="footer-menu-ul">
                                                        <ListItem />
                                                        {this.props.cmsLinks
                                                            .length > 0 &&
                                                            this.props.cmsLinks.map(
                                                                (
                                                                    link,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <ListItem
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <Link
                                                                                to={`/page/${
                                                                                    link.slug
                                                                                }`}
                                                                            >
                                                                                <FormattedMessage
                                                                                    id={
                                                                                        link.title
                                                                                    }
                                                                                    defaultMessage={
                                                                                        link.title
                                                                                    }
                                                                                />
                                                                            </Link>
                                                                        </ListItem>
                                                                    );
                                                                }
                                                            )}
                                                    </List>
                                                </div>
                                                <div className="col-sm-4 col-md-4">
                                                    <h4>
                                                        <FormattedMessage
                                                            id="popularServices"
                                                            defaultMessage="Popular Services"
                                                        />
                                                    </h4>
                                                    <ul>
                                                        {this.state.services
                                                            .length > 0 &&
                                                            this.state.services.map(
                                                                (
                                                                    service,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <li
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            <a
                                                                                style={{
                                                                                    cursor:
                                                                                        'pointer'
                                                                                }}
                                                                                onClick={() =>
                                                                                    this.redirectLink(
                                                                                        service.slug
                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    service.heading
                                                                                }
                                                                            </a>
                                                                        </li>
                                                                    );
                                                                }
                                                            )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        data-section="section"
                                        className="foot-sec2"
                                    >
                                        <div className="container">
                                            <div className="row">
                                                {/* <div className="col-sm-4 col-md-3 col-xs-12">
                                                    <h4>
                                                        <FormattedMessage
                                                            id="paymentOptions"
                                                            defaultMessage="Payment Options"
                                                        />
                                                    </h4>
                                                    <p className="hasimg">
                                                        <img src={payment} />{' '}
                                                    </p>
                                                </div> */}
                                                <div className="col-sm-4 col-md-4 col-xs-12">
                                                    <h4>
                                                        <FormattedMessage
                                                            id="address"
                                                            defaultMessage="Address"
                                                        />
                                                    </h4>
                                                    <span className="highlighted">
                                                        {
                                                            this.props.constants
                                                                .address_line1
                                                        }
                                                        ,{' '}
                                                        {
                                                            this.props.constants
                                                                .address_line2
                                                        }
                                                    </span>
                                                    <p>
                                                        {' '}
                                                        <span className="strong">
                                                            <FormattedMessage
                                                                id="phone"
                                                                defaultMessage="Phone"
                                                            />
                                                            :{' '}
                                                        </span>{' '}
                                                        <span className="highlighted">
                                                            {
                                                                this.props
                                                                    .constants
                                                                    .phone_number
                                                            }
                                                        </span>{' '}
                                                    </p>

                                                    <p>
                                                        <a className="fontlink">
                                                            <FormattedMessage
                                                                id="emailUs"
                                                                defaultMessage="Email us"
                                                            />
                                                            :{' '}
                                                            {
                                                                this.props
                                                                    .constants
                                                                    .admin_email
                                                            }
                                                        </a>
                                                    </p>
                                                </div>
                                                <div className="col-sm-4 col-md-5 col-xs-12 foot-social">
                                                    <h4>
                                                        <FormattedMessage
                                                            id="followWithUs"
                                                            defaultMessage="Follow Us"
                                                        />
                                                    </h4>
                                                    <p>
                                                        Join the thousands of
                                                        other There are many
                                                        variations of passages
                                                        of Lorem Ipsum available
                                                    </p>
                                                    <ul>
                                                        <li>
                                                            {this.props
                                                                .constants
                                                                .facebook && (
                                                                <a
                                                                    href={
                                                                        this
                                                                            .props
                                                                            .constants
                                                                            .facebook
                                                                    }
                                                                >
                                                                    <i
                                                                        className="fa fa-facebook"
                                                                        aria-hidden="true"
                                                                    />
                                                                </a>
                                                            )}
                                                        </li>
                                                        <li>
                                                            {this.props
                                                                .constants
                                                                .google && (
                                                                <a
                                                                    href={
                                                                        this
                                                                            .props
                                                                            .constants
                                                                            .google
                                                                    }
                                                                >
                                                                    <i
                                                                        className="fa fa-google-plus"
                                                                        aria-hidden="true"
                                                                    />
                                                                </a>
                                                            )}
                                                        </li>
                                                        <li>
                                                            {this.props
                                                                .constants
                                                                .instagram && (
                                                                <a
                                                                    href={
                                                                        this
                                                                            .props
                                                                            .constants
                                                                            .instagram
                                                                    }
                                                                >
                                                                    <i
                                                                        className="fa fa-instagram"
                                                                        aria-hidden="true"
                                                                    />
                                                                </a>
                                                            )}
                                                        </li>

                                                        <li>
                                                            {this.props
                                                                .constants
                                                                .linkedin && (
                                                                <a
                                                                    href={
                                                                        this
                                                                            .props
                                                                            .constants
                                                                            .linkedin
                                                                    }
                                                                >
                                                                    <i
                                                                        className="fa fa-linkedin"
                                                                        aria-hidden="true"
                                                                    />
                                                                </a>
                                                            )}
                                                        </li>
                                                        <li>
                                                            {this.props
                                                                .constants
                                                                .youtube && (
                                                                <a
                                                                    href={
                                                                        this
                                                                            .props
                                                                            .constants
                                                                            .youtube
                                                                    }
                                                                >
                                                                    <i
                                                                        className="fa fa-youtube"
                                                                        aria-hidden="true"
                                                                    />
                                                                </a>
                                                            )}
                                                        </li>
                                                        <li>
                                                            {this.props
                                                                .constants
                                                                .skypeid && (
                                                                <a
                                                                    href={
                                                                        `skype:` +
                                                                        this
                                                                            .props
                                                                            .constants
                                                                            .skypeid
                                                                    }
                                                                >
                                                                    <i
                                                                        className="fa fa-skype"
                                                                        aria-hidden="true"
                                                                    />
                                                                </a>
                                                            )}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>

                <section className="copy">
                    <div className="container">
                        <p>
                            Copyright &copy; {1900 + new Date().getYear()}{' '}
                            <a
                                href={SITE_URL}
                                className={aClasses}
                                target="_blank"
                            >
                                {' '}
                                {this.props.constants.companyName}
                            </a>
                            .&nbsp;All rights reserved.{' '}
                        </p>
                    </div>
                </section>
            </div>
        );
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
    whiteFont: PropTypes.bool
};
const mapStateToProps = ({ settings }) => {
    return { cmsLinks: settings.cmsLinks, constants: settings.constants };
};

const composedComponent = compose(
    withTheme(),
    connect(
        mapStateToProps,
        actions
    ),
    withStyles(footerStyle)
);
export default composedComponent(withUser(withRouter(Footer)));



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx